import "../common/elements/Header.scss";
import { toggleNavOrgMgt, toggleNav } from "../../static/js/commons";
import translate from "@/i18n/translate";
import { Link } from "react-router-dom";
import { scrollToTop } from "../common/helper";
import { useContext } from "react";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";

export interface MainSideNavBarProps {
  collapseSideNav: boolean;
  hideNavigatorSideNav?: boolean;
}
export default function NavigatorSideNav({
  collapseSideNav,
  hideNavigatorSideNav
}: MainSideNavBarProps): JSX.Element {
  const hide_sideNav_class = (collapseSideNav: boolean) => {
    return hideNavigatorSideNav || !collapseSideNav ? "hamburger-hide" : "";
  };

  const toggle_nav = (collapseSideNav: boolean) => {
    return toggleNavOrgMgt;
  };

  let urlPath = window.location.pathname;
  const queryString = window.location.search;
  const { institution } = useContext<AppContextInterface>(AppContext);

  function removeOverlay() {
    let nav = document.getElementById("mainnav");
    let expanded = nav?.classList.contains("expanded");
    if (expanded) {
      toggleNavOrgMgt();
    }
    scrollToTop(".home-page-header");
    scrollToTop("#page-header");
    let overlay = document.getElementById("navoverlay");
    if (overlay) {
      overlay.parentNode?.removeChild(overlay);
    }
  }

  return (
    <nav
      id="mainnav"
      className={`main-nav main-nvs items-9 ${hide_sideNav_class(
        collapseSideNav
      )}`}
    >
      <div id="nav-start-div" className="navwrapper"></div>
      <button
        id="nav-toggle"
        className="icononly show-nav-toggle"
        onClick={toggle_nav(collapseSideNav)}
      >
        <span className="sr-only tooltip -bottom -multiline">
          {translate("app.hideNavigation")}
        </span>
        <span className="hamburger-inner"></span>
      </button>

      <ul id="navmenu" className="menu  org-profile-menu">
        {/* Use "active-parent" class for li tag, based on which side nav option is selected, example given below */}
        <li
          className={
            urlPath.includes("home") ? "menuitem active-parent" : "menuitem"
          }
        >
          {/* Use "active" class for a tag, based on which side nav option is selected, example given below*/}
          <Link
            to={
              queryString.includes("locale")
                ? `/insights/home/${queryString}`
                : `/insights/home`
            }
            id="nav-home"
            className={
              urlPath.includes("home")
                ? "navlink nav-links active home-nav-link"
                : "navlink nav-links home-nav-link"
            }
            onClick={removeOverlay}
          >
            <span className="icon pe-va pe-fw pe-7s-home"></span>
            <span id="hometext">{translate("app.mainnav.home")}</span>
          </Link>
        </li>
        <li
          className={
            urlPath.includes("academic") ? "menuitem active-parent" : "menuitem"
          }
        >
          <Link
            to={
              queryString.includes("locale")
                ? `/insights/academic_office/${queryString}`
                : "/insights/academic_office"
            }
            id="org-link"
            className={
              urlPath.includes("academic")
                ? "navlink nav-links active home-nav-link"
                : "navlink nav-links home-nav-link"
            }
            onClick={removeOverlay}
          >
            <span className="icon pe-va pe-fw pe-7s-notebook"></span>
            <span id="orgtext">
              {translate("app.mainnav.academicsAndOffices")}
            </span>
          </Link>
        </li>
        <li
          className={
            urlPath.includes("settings") ? "menuitem active-parent" : "menuitem"
          }
        >
          <Link
            to={
              queryString.includes("locale")
                ? `/insights/settings/${queryString}`
                : "/insights/settings"
            }
            id="settings-link"
            className={
              urlPath.includes("settings")
                ? "navlink nav-links active home-nav-link"
                : "navlink nav-links home-nav-link"
            }
            onClick={removeOverlay}
          >
            <span className="icon pe-va pe-fw pe-7s-config"></span>
            <span id="plantext">{translate("app.home.settings")}</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
}
